module.exports = __webpack_public_path__ + "static/media/icon_gold_dim.7c7032d6.svg";